import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import moment, { Moment } from 'moment';

@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent implements OnInit {

  @Input() model: Date = new Date();
  @Input() disabled: boolean = false;

  @Input() set modelAsString(date: string) {
    const momentDate = moment(date);
    if (!momentDate.isValid()) {
      return;
    }

    const d = momentDate.toDate();

    this.model = new Date(
      d.getFullYear(),
      d.getMonth(),
      d.getDate(),
      12, 0, 0, 0
    );
    this.setDisplay(moment(this.model));
  }

  @Output() modelChange = new EventEmitter<Date>();
  @Output() changeFromCalendar = new EventEmitter<boolean>();

  display: string = "";

  private initialValue: Date | null = null;

  constructor() { }

  private isValidDate(d: any) {
    return d instanceof Date && !isNaN(d as any);
  }

  ngOnInit(): void {
  }

  inputChanged(e: any) {
    let selected = e.target.value;
    if (selected == null || selected == "") {
      selected = this.isValidDate(this.initialValue) ? this.initialValue : new Date();
    }

    const date = moment(selected).set('hours', 12);
    this.model = date.toDate();
    this.setDisplay(date);
    this.modelChange.emit(date.toDate());
    this.changeFromCalendar.emit(true);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['model'] == null) {
      return;
    }

    var dateVal = changes["model"].currentValue;
    if (dateVal != null) {
      this.setDisplay(moment(dateVal));
    }
  }

  next() {
    const date = moment(this.model).add(1, 'days');
    this.setDisplay(date);
    this.modelChange.emit(date.toDate());
    this.changeFromCalendar.emit(false);
  }

  prev() {
    const date = moment(this.model).add(-1, 'days');
    this.setDisplay(date);
    this.modelChange.emit(date.toDate());
    this.changeFromCalendar.emit(false);
  }

  setDisplay(date: Moment) {
    if (this.initialValue == null && date.isValid()) {
      this.initialValue = date.toDate();
    }
    this.display = date.format("DD-MM-yyyy");
  }

  onClick() {
    this.initialValue = moment(this.model).toDate();
  }

}
